import { z } from 'zod';

/**
 * Units of measure — per-tenant master list (ported from the old POS `d_unit`
 * table: name, sort, is_active). Items pick their base unit from this list, and
 * each extra selling unit (pack/carton) also references one by name. Reuses the
 * `items.*` permissions (inventory master data), like brands & categories.
 */
export const UnitOfMeasureSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  name: z.string().min(1).max(100),
  sort: z.number().int(),
  isActive: z.boolean(),
  /**
   * How many products use this unit as their base unit (items.unit_of_measure =
   * this unit's name). Populated by the list endpoint; omitted otherwise.
   */
  productCount: z.number().int().nonnegative().optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type UnitOfMeasure = z.infer<typeof UnitOfMeasureSchema>;

/** Lightweight product reference returned when listing a unit's related items. */
export const UnitOfMeasureItemRefSchema = z.object({
  id: z.string().uuid(),
  code: z.string(),
  name: z.string(),
  isActive: z.boolean(),
});
export type UnitOfMeasureItemRef = z.infer<typeof UnitOfMeasureItemRefSchema>;

export const UnitOfMeasureCreateSchema = z.object({
  name: z.string().min(1).max(100),
  sort: z.number().int().optional(),
});
export type UnitOfMeasureCreate = z.infer<typeof UnitOfMeasureCreateSchema>;

export const UnitOfMeasureUpdateSchema = z.object({
  name: z.string().min(1).max(100).optional(),
  sort: z.number().int().optional(),
  isActive: z.boolean().optional(),
});
export type UnitOfMeasureUpdate = z.infer<typeof UnitOfMeasureUpdateSchema>;
